import { render, staticRenderFns } from "./MenuBuilderPage.vue?vue&type=template&id=00454093&scoped=true&"
import script from "./MenuBuilderPage.vue?vue&type=script&lang=js&"
export * from "./MenuBuilderPage.vue?vue&type=script&lang=js&"
import style0 from "./MenuBuilderPage.vue?vue&type=style&index=0&id=00454093&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00454093",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00454093')) {
      api.createRecord('00454093', component.options)
    } else {
      api.reload('00454093', component.options)
    }
    module.hot.accept("./MenuBuilderPage.vue?vue&type=template&id=00454093&scoped=true&", function () {
      api.rerender('00454093', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pages/MenuBuilderPage.vue"
export default component.exports